import { templateStore } from '../../template/index.js';

/**
 * Render an alert into a container
 * @param {HTMLElement} container - The container to append the alert to
 * @param {Object} options - { type, title, message, duration }
 */
export function displayAlert(container, options = {}) {
	if (!container) return;

	const template = templateStore.get('alert.ejs');
	if (!template) {
		console.error('[Alert] Template "alert.ejs" not preloaded.');
		return;
	}

	const data = {
		type: options.type || 'info',
		title: options.title || '',
		message: options.message || '',
	};

	// eslint-disable-next-line no-undef
	const html = ejs.render(template, data);

	container.insertAdjacentHTML('beforeend', html);

	const alertElement = container.lastElementChild;

	const duration = options.duration || 5000;
	
	if (options.duration !== false) {
		setTimeout(() => {
			removeAlert(alertElement);
		}, duration);
	}

	return alertElement;
}

/**
 * Remove alert element with optional transition
 * @param {HTMLElement} element 
 */
export function removeAlert(element) {
    if (!element || !element.parentNode) return;
    
    // You can add fade-out classes here if defined in CSS
    element.remove();
}
